import styled from "styled-components";
import Title from "../../../../../base/text/title/views/mobile/index.js";
import { PriceCaptionMobile } from "../../../../cards/product-card/views/mobile/prices/styled.js";
import { ProductCardContent, ProductCardImageContainer } from "../../../../cards/product-card/views/mobile/styled.js";
import Tabs from "../../../../../structures/others/tabs/index.js";
export const TitleWrapperMobile = styled(Title).withConfig({
    displayName: "styled__TitleWrapperMobile",
    componentId: "sc-3326086e-0"
})`
	margin-top: 12px;
	margin-bottom: 12px;
	text-align: center;
	padding: 0 16px;
`;
export const TabsProductWrapperMobile = styled(Tabs).withConfig({
    displayName: "styled__TabsProductWrapperMobile",
    componentId: "sc-3326086e-1"
})`
	background-color: ${({ theme  })=>theme.bodyBgColor};
	box-shadow: unset;
	border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.light};

	& > ul {
		background-color: ${({ theme  })=>theme.colors.white.base};
	}

	${ProductCardContent} {
		padding: 5px 12px;
		min-height: 70px;
	}

	${ProductCardImageContainer} {
		img {
			width: inherit;
		}
	}
	// TRANSPORT
	${PriceCaptionMobile} {
		order: -1;
		color: ${({ theme  })=>theme.colors.secondary.base};
		font-weight: ${({ theme  })=>theme.font.weight.light};
		font-size: ${({ theme  })=>theme.font.size.small};
	}
	// END TRANSPORT
`;

//# sourceMappingURL=styled.js.map